const state = {
  all: [],
  loading: false
}

export const getters = {
  all: state => state.all,
  loading: state => state.loading
}

export const mutations = {
  setAll(state, components) {
    state.all = JSON.parse(JSON.stringify(components))
    state.loading = false
  }
}

export const actions = {
  fetchAll({ commit, state }, profileQualification) {
    Object.assign({ institution: {}, qualificationType: {} }, profileQualification)
    state.loading = true
    return api
      .getComponentsFor(profileQualification)
      .then(response => commit('setAll', response.data), error => (state.loading = false))
  }
}

export const api = {
  getComponentsFor: ({ institution, qualificationType }) => {
    const params = [
      institution && institution.id ? `institution=${institution.id}` : '',
      qualificationType && qualificationType.id ? `qualification_type=${qualificationType.id}` : ''
    ].join('&')
    return Vue.$http.get(`/qualification_components?${params}`)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
